import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { AppProviders } from './providers'
import { AppRouter } from './router'
import './index.css'

// Reload on chunk load failure (stale browser tab after Vercel redeploy)
window.addEventListener('vite:preloadError', () => {
  window.location.reload()
})

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Failed to find the root element')

// Mock mode (local dev via `VITE_MOCK_API=1 bun run dev` and `development` builds on portal-dev, never `main`): start MSW before first render.
if (import.meta.env.VITE_MOCK_API === '1') {
  try {
    await (await import('./mocks/startMocks')).startMocks()
  } catch (err) {
    console.error('[mocks] failed to start MSW, rendering without mocks', err)
  }
}

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders>
      <AppRouter />
    </AppProviders>
  </StrictMode>,
)
